var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("¡Se han extraviado algunas piezas de esta sala! Descubre las pistas y resuelve los Mini-juegos para recuperarlas")])])}]

export { render, staticRenderFns }